import { t } from '@life/i18n';

/** Контакт помощи: сопровождает каждую тяжёлую запись и экран смерти при тяжёлой причине. */
export function HelpBlock() {
  return (
    <div class="alert info" role="note">
      {t('help.lines')}
    </div>
  );
}
